<template>
  <div v-if="!isLoading" class="l-main-content">
    <div :class="className" class="p-project-edit p-project-edit--readonly">
      <div class="p-dialog-option-tabs__title-row">
        <div class="c-title">
          <div class="c-title__text u-fs24">プレオプトイン・ブロック解除バーオプションタグ</div>
        </div>
        <button
          class="c-btn c-btn--modal c-btn--blue p-dialog-option-tabs__preview-btn"
          :class="{ 'is-active': isPreviewShown }"
          type="button"
          @click="onPreviewClick"
        >
          <p class="c-btn__text">{{ isPreviewShown ? 'プレビュー中' : 'プレビュー' }}</p>
        </button>
      </div>
      <div v-if="hasV1Data" class="p-dialog-option-tabs__bar">
        <ul class="p-dialog-option-tabs__list">
          <li
            class="p-dialog-option-tabs__item"
            :class="{ 'is-active': activeTab === 'v2' }"
            @click="activeTab = 'v2'"
          >V2(新デザイン)</li>
          <li
            class="p-dialog-option-tabs__item"
            :class="{ 'is-active': activeTab === 'v1' }"
            @click="activeTab = 'v1'"
          >V1(旧デザイン)</li>
        </ul>
      </div>
      <div class="p-dialog-option-tabs__panel">
        <div v-show="activeTab === 'v2'">
          <DialogOptionV2Module
            :copy-id="v2CopyId"
            :project-icon-url="projectIconUrl"
            :initial-data="v2InitialData"
            :show-preview="isPreviewShown && activeTab === 'v2'"
            :is-active="activeTab === 'v2'"
            @close-preview="isPreviewShown = false"
            @toggle-preview="isPreviewShown = !isPreviewShown"
          />
        </div>
        <div v-show="activeTab === 'v1'">
          <DialogOptionModule
            :copy-id="copyId"
            :service-create-date="serviceCreateDate"
            :project-icon-url="projectIconUrl"
            :initial-data="v1InitialData"
            :show-preview="isPreviewShown && activeTab === 'v1'"
            :is-active="activeTab === 'v1'"
            @close-preview="isPreviewShown = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DialogOptionModule from './DialogOptionModule.vue';
import DialogOptionV2Module from './DialogOptionV2Module.vue';

export default {
  components: { DialogOptionModule, DialogOptionV2Module },
  props: {
    copyId: String,
    className: String,
    serviceCreateDate: {
      type: String,
      default: '',
    },
    projectIconUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeTab: 'v2',
      isPreviewShown: false,
      hasV1Data: false,
      v1InitialData: null,
      v2InitialData: null,
      isLoading: true,
    };
  },
  computed: {
    v2CopyId() {
      return `${this.copyId}-v2`;
    },
  },
  mounted() {
    this.fetchOptionTagSettings();
  },
  methods: {
    fetchOptionTagSettings: function () {
      Promise.all([
        axios.get('/api/script-tag-setting/get-option-v2').catch(() => ({ data: null })),
        axios.get('/api/script-tag-setting/get-option').catch(() => ({ data: null })),
      ]).then(([v2Res, v1Res]) => {
        this.v2InitialData = v2Res.data || null;
        this.v1InitialData = v1Res.data || null;
        this.hasV1Data = this.hasSetting(v1Res.data);
        if (this.hasSetting(v2Res.data)) {
          this.activeTab = 'v2';
        } else if (this.hasV1Data) {
          this.activeTab = 'v1';
        } else {
          this.activeTab = 'v2';
        }
        this.isLoading = false;
      });
    },
    hasSetting: function (data) {
      if (!data) {
        return false;
      }
      if (typeof data !== 'object') {
        return false;
      }
      return Object.keys(data).some(key => {
        const value = data[key];
        return value !== undefined && value !== null && value !== '' && value !== false;
      });
    },
    onPreviewClick: function () {
      this.isPreviewShown = !this.isPreviewShown;
    },
  },
};
</script>

<style scoped>
.p-dialog-option-tabs__title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}
.p-dialog-option-tabs__title-row .c-title {
    flex: 1 1 auto;
    min-width: 0;
}
/* onboarding ページ用: タイトル文字を小さく、左寄せ、下線を行全体に伸ばし、下線までの間隔を狭くする */
.p-project-edit-for-onbording .p-dialog-option-tabs__title-row {
    align-items: flex-end;
    padding-bottom: 8px;
    border-bottom: 1px solid #ccc;
}
.p-project-edit-for-onbording .p-dialog-option-tabs__title-row .c-title {
    padding-bottom: 0;
    border-bottom: none;
}
.p-project-edit-for-onbording .p-dialog-option-tabs__title-row .c-title__text {
    font-size: 18px !important;
    text-align: left;
}
.p-dialog-option-tabs__bar {
    align-items: baseline;
    display: flex;
    justify-content: space-between;
}
.p-dialog-option-tabs__list {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
}
.p-dialog-option-tabs__preview-btn {
    flex: 0 0 auto;
    width: 120px !important;
    height: auto;
    min-height: 0;
    padding: 4px 12px;
    margin-left: auto;
    font-size: 15px;
    line-height: 1.4;
    background: #9d9d9d;
}
.p-dialog-option-tabs__preview-btn .c-btn__text {
    font-size: 15px;
    padding: 0;
    margin: 0;
    line-height: 1.4;
}
.p-dialog-option-tabs__preview-btn.is-active {
    background: #57606a;
}
.p-dialog-option-tabs__item {
    padding: 10px 24px;
    cursor: pointer;
    font-size: 15px;
    font-weight: bold;
    color: #57606a;
    border-radius: 6px 6px 0 0;
    margin-right: 4px;
    background: #f6f8fa;
    transition: color .2s, background-color .2s;
}
.p-dialog-option-tabs__item.is-active {
    color: #209bb9;
    background: #ffffff;
}
.p-dialog-option-tabs__item:hover:not(.is-active) {
    color: #24292f;
    background: #eaeef2;
}
.p-dialog-option-tabs__panel {
    padding: 0 16px 16px 16px;
    background: #ffffff;
}
.p-dialog-option-tabs__panel :deep(.p-project-edit-list) {
    margin-top: 0;
}
</style>
